module.exports = __webpack_public_path__ + "43f2306bbd5c816fa3bfb9ae01cd5f07.svg";